import * as React from 'react'
const MessageBoardIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M28.66 3a.51.51 0 01.26.22.53.53 0 010 .46l-7.79 23.8a.54.54 0 01-.43.37L13.54 29a.55.55 0 01-.54-.3l-3.24-6.46L3.3 19a.55.55 0 01-.3-.54l1.1-7.21a.54.54 0 01.37-.43L28.28 3a.5.5 0 01.38 0zm-2.18 1.75L10.06 21.18l-5.93-2.95 1-6.49zM10.82 21.94l2.95 5.93 6.49-1 7-21.35z" className="-secondary-color" fill="#d7dae0" fillRule="evenodd"/>
    </svg>
    
  )
}

export default MessageBoardIcon